module.exports = {
      id: "arrow-bottom-gray-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#arrow-bottom-gray",
      toString: function () {
        return this.url;
      }
    }